import {
  cleanup,
  fireEvent,
  render,
  screen,
  waitFor,
} from '@testing-library/react';
import * as React from 'react';
import { Provider } from 'react-redux';
import { expect } from 'vitest';

import redux from '../../redux';
import SaveButton from './save-button';

function TestComponent() {
  return (
    <Provider store={redux.store}>
      <SaveButton />
    </Provider>
  );
}

describe('save button', () => {
  afterEach(() => {
    cleanup();
  });

  test('save button should be disabled', () => {
    render(<TestComponent />);
    const button = screen.getByText('save');
    expect(button).toBeDefined();
    expect(button).toBeDisabled();
  });

  test('save button should close the modal upon button click', async () => {
    render(<TestComponent />);
    redux.store.dispatch(redux.bulkPauseUnpause.setAction('unpause'));
    const button = screen.getByText('save');
    expect(button).toBeDefined();
    await waitFor(() => expect(button).not.toBeDisabled());
    const spy = vi.spyOn(redux.modal, 'close');
    fireEvent.click(button);
    expect(spy).toHaveBeenCalledTimes(1);
  });
});
